import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import UserDataQuery from './UserDataQuery';

const UserDataConnectorApollo = ({ children }) => {
  const [loadUserData] = useLazyQuery(UserDataQuery);

  const fetch = async () => {
    const result = await loadUserData();
    localStorage.setItem('userEmail', result?.data?.me?.email || '');
    localStorage.setItem('userId', result?.data?.me?.id || '');
    return result;
  };

  return children({
    userDataOnDemand: fetch,
  });
};

UserDataConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default UserDataConnectorApollo;
